import { useState } from 'react';
import './AdminPage.css';
import IkusasalethuGroupLogo from './img/IkusasalethuGroupLogo.jpg';

function AdminPage({ isAuthed, onAuthed }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const [plans, setPlans] = useState([
    { id: 1, name: 'Plan 1', premium: 79, cover: 10000, mostPopular: false },
    { id: 2, name: 'Plan 2', premium: 89, cover: 15000, mostPopular: true },
    { id: 3, name: 'Plan 3', premium: 105, cover: 20000, mostPopular: false },
  ]);

  const [newPlan, setNewPlan] = useState({ name: '', premium: '', cover: '', mostPopular: false });

  const handleLogin = (e) => {
    e.preventDefault();
    const validUser = username.trim().toLowerCase() === 'admin';
    const validPass = password === 'Admin123!';
    if (validUser && validPass) {
      setError('');
      onAuthed();
    } else {
      setError('Incorrect username or password.');
    }
  };

  //this function is used to change the plan details
  const handlePlanChange = (id, field, value) => {
    setPlans((prev) =>
      prev.map((plan) =>
        plan.id === id
          ? {
              ...plan,
              [field]: field === 'premium' || field === 'cover' ? Number(value) || '' : value,
            }
          : plan
      )
    );
  };

  const handleMostPopularToggle = (id) => {
    setPlans((prev) =>
      prev.map((plan) => ({
        ...plan,
        mostPopular: plan.id === id,
      }))
    );
  };

  const handleAddPlan = (e) => {
    e.preventDefault();
    if (!newPlan.name || !newPlan.premium || !newPlan.cover) {
      return;
    }
    const nextId = plans.length ? Math.max(...plans.map((p) => p.id)) + 1 : 1;
    setPlans((prev) => [
      ...prev,
      {
        id: nextId,
        name: newPlan.name,
        premium: Number(newPlan.premium),
        cover: Number(newPlan.cover),
        mostPopular: newPlan.mostPopular,
      },
    ]);
    setNewPlan({ name: '', premium: '', cover: '', mostPopular: false });
  };

  if (!isAuthed) {
    return (
      <div className="admin-root">
        <div className="admin-shell">
          <div className="admin-login-card">
            <h1>Ikusasalethu Group · Admin</h1>
            <p className="admin-muted">
              Restricted access. Enter the admin credentials to manage plan information.
            </p>
            <form onSubmit={handleLogin} className="admin-form">
              <label className="admin-label">
                Username
                <input
                  className="admin-input"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  autoComplete="username"
                />
              </label>
              <label className="admin-label">
                Password
                <input
                  className="admin-input"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  autoComplete="current-password"
                />
              </label>
              {error && <p className="admin-error">{error}</p>}
              <button type="submit" className="btn btn--primary btn--full">
                Sign in
              </button>
            </form>
            <p className="admin-footnote">
              This page is intended for Servi Contact administrators to manage funeral cover plans.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-root">
      <header className="top-bar">
        <div className="container top-bar__inner">
          <div className="top-bar__brand">
            <div className="logo-mark">
              <img
                src={IkusasalethuGroupLogo}
                alt="Ikusasalethu Group logo"
                className="logo-mark__img"
              />
            </div>
            <div className="top-bar__brand-text">
              <span className="brand-name">Ikusasalethu Group</span>
              <span className="brand-sub">Internal admin · Plans</span>
            </div>
          </div>
        </div>
      </header>

      <main className="admin-main">
        <div className="container admin-main-inner">
          <section className="admin-header">
            <h1>Plan management</h1>
            <p className="admin-muted">
              Review, update and create funeral cover plans. Changes here will later drive the
              public pricing table.
            </p>
          </section>

          <section className="admin-section">
            <div className="admin-section-header">
              <h2>Existing plans</h2>
              <p className="admin-muted">Adjust premiums, cover amounts, and mark the most popular plan.</p>
            </div>
            <div className="admin-card">
              <div className="admin-table">
                <div className="admin-table__head">
                  <span>Name</span>
                  <span>Monthly premium (R)</span>
                  <span>Cover amount (R)</span>
                  <span>Most popular</span>
                </div>
                <div className="admin-table__body">
                  {plans.map((plan) => (
                    <div key={plan.id} className="admin-table__row">
                      <input
                        className="admin-input admin-input--inline"
                        value={plan.name}
                        onChange={(e) => handlePlanChange(plan.id, 'name', e.target.value)}
                      />
                      <input
                        className="admin-input admin-input--inline"
                        type="number"
                        value={plan.premium}
                        onChange={(e) => handlePlanChange(plan.id, 'premium', e.target.value)}
                      />
                      <input
                        className="admin-input admin-input--inline"
                        type="number"
                        value={plan.cover}
                        onChange={(e) => handlePlanChange(plan.id, 'cover', e.target.value)}
                      />
                      <button
                        type="button"
                        className={
                          plan.mostPopular ? 'admin-tag admin-tag--gold' : 'admin-tag admin-tag--ghost'
                        }
                        onClick={() => handleMostPopularToggle(plan.id)}
                      >
                        {plan.mostPopular ? 'Most popular' : 'Set as most popular'}
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </section>

          <section className="admin-section">
            <div className="admin-section-header">
              <h2>Create new plan</h2>
              <p className="admin-muted">
                Capture a new structured funeral cover option to appear alongside existing plans.
              </p>
            </div>
            <div className="admin-card">
              <form className="admin-grid" onSubmit={handleAddPlan}>
                <label className="admin-label">
                  Plan name
                  <input
                    className="admin-input"
                    value={newPlan.name}
                    onChange={(e) => setNewPlan((p) => ({ ...p, name: e.target.value }))}
                    placeholder="e.g. Plan 4"
                  />
                </label>
                <label className="admin-label">
                  Monthly premium (R)
                  <input
                    className="admin-input"
                    type="number"
                    value={newPlan.premium}
                    onChange={(e) => setNewPlan((p) => ({ ...p, premium: e.target.value }))}
                    placeholder="e.g. 129"
                  />
                </label>
                <label className="admin-label">
                  Cover amount (R)
                  <input
                    className="admin-input"
                    type="number"
                    value={newPlan.cover}
                    onChange={(e) => setNewPlan((p) => ({ ...p, cover: e.target.value }))}
                    placeholder="e.g. 25000"
                  />
                </label>
                <label className="admin-checkbox">
                  <input
                    type="checkbox"
                    checked={newPlan.mostPopular}
                    onChange={(e) => setNewPlan((p) => ({ ...p, mostPopular: e.target.checked }))}
                  />
                  <span>Mark as most popular</span>
                </label>
                <div className="admin-actions">
                  <button type="submit" className="btn btn--primary">
                    Add plan (layout only)
                  </button>
                  <p className="admin-muted admin-small-note">
                    This is a layout prototype. A database connection can be added later without
                    changing this screen.
                  </p>
                </div>
              </form>
            </div>
          </section>
        </div>
      </main>
    </div>
  );
}

export default AdminPage;

